import { useCallback, useContext } from 'react';
import { FeatureTogglesContext } from '../components';
import { FEATURES } from '../constants';
import type { IFeatureToggles } from '../types';

export interface IUseFeatureToggles {
  isFeatureOn: (feature: `${FEATURES}`) => boolean;
  features: IFeatureToggles;
}

export const useFeatureToggles = (): IUseFeatureToggles => {
  const features = useContext(FeatureTogglesContext);

  if (!features) {
    Error('useFeatureToggles must be used within a <FeatureTogglesProvider>');
  }

  const isFeatureOn = useCallback((feature: string) => features[feature] ?? false, [features]);

  return {
    isFeatureOn,
    features
  };
};
